const extensionsMap = {
  'image/jpeg': '.jpg,.jpeg',
  'image/png': '.png',
  'image/gif': '.gif',
  'image/bmp': '.bmp',
  'application/pdf': '.pdf',
};


export const getAvailableExtensionToUpload = (state) => {
  const { fileMetaDataConfig } = state.appointmentInfo.patientMedia;

  return fileMetaDataConfig.map(({ mimeType }) => extensionsMap[mimeType]).join(',');
};

